import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  modulesListRequest,
  modulesListSuccess,
  modulesListFailure,
} from '../reducers/modulesList';
import { authUserFailure } from '../reducers/login';
import { API_LINK } from '../../constants';

const API = `${API_LINK}api/getModulesForProgram`;

function* modulesListAxios() {
  const state = yield select(fullState => fullState);
  const programId = state.modulesListReducer.selectedProgramId;
  const { token } = state.loginReducer;

  const response = yield call(() =>
    axios({
      method: 'get',
      url: `${API}?programId=${programId}`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
    }),
  );

  return response;
}

function* workerModulesListSaga() {
  try {
    const response = yield call(modulesListAxios);

    const responseFromModulesList = response.data;
    yield put(modulesListSuccess(responseFromModulesList));

    if (response.status === 500) {
      yield put(authUserFailure(response));
    }
  } catch (error) {
    yield put(modulesListFailure(error.response));
  }
}

export function* watcherModulesListSaga() {
  yield takeLatest(modulesListRequest().type, workerModulesListSaga);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/get_modulesList.js